import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { deletePartner } from "../../features/admin/PartnerSlice";
import MediaModal from "../../components/admin/MediaModal";
import { toast } from "react-toastify";
import { fetchMedias } from "../../features/admin/MediaSlice";
import { CheckIcon } from "@heroicons/react/24/solid";
import { TrashIcon } from "@heroicons/react/24/solid";
import ConfirmDeleteModal from "../../components/ConfirmDeleteModal";
import ApiCustom from "../../utils/ApiCustom";

const getUserPermissions = () => {
  const permissions = localStorage.getItem("permissions");
  return permissions
    ? JSON.parse(permissions).map((p) => p.permissionSlug)
    : [];
};

const userId = localStorage.getItem("userId");
const hasPermission = (requiredPermission) => {
  if (userId == 1) {
    return true;
  }
  const userPermissions = getUserPermissions();
  return userPermissions.includes(requiredPermission);
};

const ImageManagerModal = ({
  onClose,
  onPress,
  multiImage,
  selectedMultiMedia,
  onInsertImage,
  onInsertImageFormUrl,
  deActiveInsertImage = false,
}) => {
  const dispatch = useDispatch();
  const { medias, status, error } = useSelector((state) => state.medias);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [activeTab, setActiveTab] = useState("media");
  const [imageUrl, setImageUrl] = useState("");
  const [isConfirmDeleteMediaOpent, setIsConfirmDeleteMediaOpent] = useState();
  const [deleteId, setDeleteId] = useState(null);
  const [filtedMedias, setFiltedMedias] = useState();

  useEffect(() => {
    setFiltedMedias(medias.filter((media) => media.imageableType == "product"));
  }, [medias]);

  const handleOpenDeleteMediaMoal = async (media) => {
    setDeleteId(media.id);
    setIsConfirmDeleteMediaOpent(true);
  };

  const handleCloseDeleteMediaMoal = async () => {
    setIsConfirmDeleteMediaOpent(false);
  };

  const handleDeleteMedia = async () => {
    const res = await ApiCustom.delete(`/delete-media/${deleteId}`);
    if (res.status === 200) {
      setFiltedMedias((prev) => prev.filter((media) => media.id !== deleteId));
      toast.success("Xóa hình ảnh thành công!");
    } else {
      toast.error("Xóa không thành công!");
    }

    handleCloseDeleteMediaMoal();
  };

  const handleOpenModal = (media = null) => {
    setSelectedMedia(media);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedMedia(null);
  };

  const handleDelete = (id) => {
    dispatch(deletePartner(id)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        toast.success("Xóa hình ảnh thành công!");
        handleCloseModal();
      } else {
        toast.error("Đã xảy ra lỗi khi xóa hình ảnh!");
      }
    });
  };

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchMedias());
    }
  }, [status, dispatch]);

  if (status === "loading") return <p>Loading...</p>;
  if (status === "failed") return <p>Error: {error}</p>;

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50 overflow-y-auto">
      <div className="bg-base-100 rounded-lg shadow-xl xl:w-5/6 lg:w-11/12 md:w-11/12 sm:w-11/12 w-11/12 max-h-[90vh] overflow-y-auto">
        <div className="">
          <div className="p-6 pb-2 sticky top-0 bg-base-100 z-10">
            <div className="flex justify-between items-center">
              <h1 className="text-2xl font-semibold mb-4">Quản lý hình ảnh</h1>
              <button
                onClick={onClose}
                className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-base-700 bg-base-100 hover:bg-base-200"
              >
                X
              </button>
            </div>
            <div className="flex justify-between items-center mb-4">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  handleOpenModal();
                }}
                className="btn btn-success transition-colors px-4 py-2 rounded"
              >
                + Thêm hình ảnh
              </button>
            </div>

            <div className="mb-4">
              <div className="flex border-b">
                <button
                  className={`px-4 py-2 ${
                    activeTab === "media"
                      ? "border-b-2 border-blue-500 text-blue-500"
                      : "text-gray-500"
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveTab("media");
                  }}
                >
                  Ảnh đã tải lên
                </button>
                {!deActiveInsertImage && (
                  <button
                    className={`px-4 py-2 ${
                      activeTab === "url"
                        ? "border-b-2 border-blue-500 text-blue-500"
                        : "text-gray-500"
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveTab("url");
                    }}
                  >
                    Thêm ảnh từ URL
                  </button>
                )}
              </div>
            </div>
          </div>

          <div className="relative px-6">
            <div
              className={`transition-opacity duration-300 ${
                activeTab === "media" ? "opacity-100" : "opacity-0 absolute"
              }`}
            >
              {activeTab === "media" && (
                <>
                  {medias != null && medias?.length > 0 && (
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2">
                      {filtedMedias?.map((media) => (
                        <div
                          key={media.id}
                          className={`relative border rounded-lg overflow-hidden shadow-sm cursor-pointer p-2 ${
                            selectedMultiMedia
                              .map((e) => e.id)
                              .includes(media.id)
                              ? "border-blue-500"
                              : "border-transparent"
                          }`}
                          onClick={() => {
                            setSelectedMedia(media.id);
                            onPress(media);
                          }}
                        >
                          <img
                            src={media.url}
                            alt="Media"
                            className="w-full h-32 lg:h-34 xl:h-48 object-contain rounded-lg"
                            loading="lazy"
                          />
                          {selectedMultiMedia
                            .map((e) => e.id)
                            .includes(media.id) && (
                            <div className="absolute top-2 left-2 p-1 bg-white rounded-full border-2 border-white">
                              <CheckIcon className="w-6 h-6 text-blue-500" />
                            </div>
                          )}
                          {hasPermission("MEDIA_DELETE") &&
                            !selectedMultiMedia
                              .map((e) => e.id)
                              .includes(media.id) && (
                              <button
                                className="absolute flex justify-center w-10 top-4 right-4 bg-red-500 text-white rounded-lg p-1 shadow-md hover:bg-red-600"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleOpenDeleteMediaMoal(media);
                                }}
                              >
                                <TrashIcon className="w-5 h-5" />
                              </button>
                            )}
                        </div>
                      ))}
                    </div>
                  )}

                  {filtedMedias == null ||
                    (filtedMedias?.length == 0 && (
                      <p className="text-center text-gray-500 py-4">
                        Chưa có ảnh được tải lên
                      </p>
                    ))}
                </>
              )}
            </div>

            <div
              className={`transition-opacity duration-300 ${
                activeTab === "url" ? "opacity-100" : "opacity-0 absolute"
              }`}
            >
              {activeTab === "url" && (
                <div className="flex flex-col items-center w-full">
                  <input
                    type="text"
                    placeholder="Nhập URL hình ảnh"
                    value={imageUrl}
                    onChange={(e) => setImageUrl(e.target.value)}
                    className="input input-bordered w-full mb-4"
                  />
                </div>
              )}
            </div>
          </div>

          {!deActiveInsertImage && (
            <div className="flex sticky border-t bottom-0 bg-base-100 z-10 justify-end pt-4 p-6">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  if (activeTab == "url") {
                    onInsertImageFormUrl(imageUrl);
                  } else {
                    onInsertImage();
                  }
                  onClose();
                }}
                className="btn btn-success transition-colors px-4 py-2 rounded-lg"
              >
                Thêm
              </button>
            </div>
          )}

          {isModalOpen && (
            <MediaModal
              imageableId={userId}
              media={selectedMedia}
              onClose={handleCloseModal}
              onDelete={() => handleDelete(selectedMedia?.id)}
              multiImage={multiImage}
            />
          )}

          <ConfirmDeleteModal
            isOpen={isConfirmDeleteMediaOpent}
            onClose={handleCloseDeleteMediaMoal}
            onConfirm={handleDeleteMedia}
          />
        </div>
      </div>
    </div>
  );
};

export default ImageManagerModal;
